enum ExportActions {
  COPY = 'copy',
  CSV = 'csv',
  XLSX = 'xlsx',
  PRINT = 'print',
  PDF = 'pdf',
}

export default ExportActions;
